import { Image } from '@absolutelabs/react-component-library';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useFont from '../../../../../components/hooks/useFont';
import {
  selectCurrPage,
  selectFieldSettings,
} from '../../../../../store/reducers/forms';

const ImageField = ({ field }) => {
  const currPage = useSelector(selectCurrPage);
  const fieldSettings = useSelector(selectFieldSettings);
  const [fieldConfig, setFieldConfig] = useState({});
  const { font } = useFont('paragraph');

  useEffect(() => {
    const currPageSettings = fieldSettings.find((o) => o.pageName === currPage);
    const config = currPageSettings?.fields?.find(
      (x) => x.field_id === field?.id
    );
    if (config) {
      setFieldConfig(config);
    }
  }, [fieldSettings, currPage, field?.id]);

  return (
    <Image
      url={
        fieldConfig.url ||
        'https://storage.googleapis.com/abs-assets/form/819875e0-1fa1-4588-adb8-8d98b663a05e.png'
      }
      width={fieldConfig.width || 50}
      imageAlign={fieldConfig.imageAlign || 'center'}
      caption={fieldConfig.caption || ''}
      font={font}
    />
  );
};

export default ImageField;
